import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardGuard } from './dashboard.guard';
import { CanDeactivateGuard } from './guards/can-deactivate-guard';

import { DashboardComponent } from './dashboard.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ContentComponent } from './content/content.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

import { UserComponent } from './pages/users/user/user.component';
import { UserCrudComponent } from './pages/users/user-crud/user-crud.component';
import { SettingComponent } from './pages/setting/setting.component';
import { StoreComponent } from './pages/stores/store/store.component';
import { CurrencyComponent } from './pages/currencies/currency/currency.component';
import { CurrencyCrudComponent } from './pages/currencies/currency-crud/currency-crud.component';
import { StoreTypeComponent } from './pages/store_types/store-type/store-type.component';
import { StoreTypeCrudComponent } from './pages/store_types/store-type-crud/store-type-crud.component';
import { CategoryComponent } from './pages/categories/category/category.component';
import { CategoryCrudComponent } from './pages/categories/category-crud/category-crud.component';
import { CountryComponent } from './pages/countries/country/country.component';
import { CountryCrudComponent } from './pages/countries/country-crud/country-crud.component';
import { UnitComponent } from './pages/units/unit/unit.component';
import { UnitCrudComponent } from './pages/units/unit-crud/unit-crud.component';
import { ManufactureComponent } from './pages/manufacturers/manufacture/manufacture.component';
import { ManufactureCrudComponent } from './pages/manufacturers/manufacture-crud/manufacture-crud.component';
import { ProductComponent } from './pages/products/product/product.component';
import { ProductCrudComponent } from './pages/products/product-crud/product-crud.component';
import { StoreCrudComponent } from './pages/stores/store-crud/store-crud.component';
import { RoleComponent } from './pages/roles/role/role.component';
import { RoleCrudComponent } from './pages/roles/role-crud/role-crud.component';
import { ExpenseComponent } from './pages/expenses/expense/expense.component';
import { ExpenseCrudComponent } from './pages/expenses/expense-crud/expense-crud.component';
import { ExpenseTypeComponent } from './pages/expense_types/expense-type/expense-type.component';
import { ExpenseTypeCrudComponent } from './pages/expense_types/expense-type-crud/expense-type-crud.component';
import { PermissionComponent } from './pages/permissions/permission/permission.component';
import { PermissionCrudComponent } from './pages/permissions/permission-crud/permission-crud.component';
import { ContractorComponent } from './pages/contractors/contractor/contractor.component';
import { ContractorCrudComponent } from './pages/contractors/contractor-crud/contractor-crud.component';
import { ContractorTypeComponent } from './pages/contractor_types/contractor-type/contractor-type.component';
import { ContractorTypeCrudComponent } from './pages/contractor_types/contractor-type-crud/contractor-type-crud.component';

import { ReceiptComponent } from './pages/reseipts/receipt/receipt.component';
import { ReceiptItemsComponent } from './pages/reseipts/receipt-items/receipt-items.component';

import { CurrencyRateComponent } from './pages/currency_rates/currency-rate/currency-rate.component';
import { CurrencyRateCrudComponent } from './pages/currency_rates/currency-rate-crud/currency-rate-crud.component';

import { SaleComponent } from './pages/sales/sale/sale.component';
import { SaleItemsComponent } from './pages/sales/sale-items/sale-items.component';
import { SaleUpdateComponent } from './pages/sales/sale-update/sale-update.component';

import { CashboxComponent } from './pages/cashboxes/cashbox/cashbox.component';

import { ProductStorageComponent } from './pages/product_storages/product-storage/product-storage.component';
import { OperationTypeComponent } from './pages/operation_types/operation-type/operation-type.component';

import { OperationComponent } from './pages/operations/operation/operation.component';
import { OperationItemsComponent } from './pages/operations/operation-items/operation-items.component';

import { CellComponent } from './pages/cells/cell/cell.component';
import { CellCrudComponent } from './pages/cells/cell-crud/cell-crud.component';

import { ContactComponent } from './pages/contacts/contact/contact.component';
import { ContactCrudComponent } from './pages/contacts/contact-crud/contact-crud.component';

import { AccountComponent } from './pages/accounts/account/account.component';
import { AccountCrudComponent } from './pages/accounts/account-crud/account-crud.component';

import { PositionComponent } from './pages/positions/position/position.component';
import { PositionCrudComponent } from './pages/positions/position-crud/position-crud.component';

import { ProductTarifComponent } from './pages/product_tarifs/product-tarif/product-tarif.component';
import { ProductTarifCrudComponent } from './pages/product_tarifs/product-tarif-crud/product-tarif-crud.component';

import { OwnershipTypeComponent } from './pages/ownership_types/ownership-type/ownership-type.component';
import { OwnershipTypeCrudComponent } from './pages/ownership_types/ownership-type-crud/ownership-type-crud.component';

import { TarifNameComponent } from './pages/tarifs/tarif-name/tarif-name.component';
import { TarifNameCrudComponent } from './pages/tarifs/tarif-name-crud/tarif-name-crud.component';

import { RegionComponent } from './pages/regions/region/region.component';
import { CityComponent } from './pages/cities/city/city.component';
import { NewsComponent } from './pages/news/news/news.component';
import { NewsCrudComponent } from './pages/news/news-crud/news-crud.component';

import { ReportComponent } from './pages/reports/report/report.component';
import { FilterComponent } from '../utils/filter/filter.component';
import { NotificationComponent } from '../utils/notification/notification.component';
import { OperationListItemComponent } from './pages/operations/operation-list-item/operation-list-item.component';
import { SaleListItemsComponent } from './pages/sales/sale-list-items/sale-list-items.component';

import {TransactionPurposeTypeComponent } from './pages/transaction_purpose_types/transaction-purpose-type/transaction-purpose-type.component';
import {TransactionPurposeTypeCrudComponent } from './pages/transaction_purpose_types/transaction-purpose-type-crud/transaction-purpose-type-crud.component';
import { ReceiptListItemsComponent } from './pages/reseipts/receipt-list-items/receipt-list-items.component';
import { ReceiptUpdateComponent } from './pages/reseipts/receipt-update/receipt-update.component';





const dashboardRoutes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    // canDeactivate: [CanDeactivateGuard],
    children : [
           { 
             path: '', 
             // path: 'user', 
            //  component: OperationComponent, 
             // canActivate: [DashboardGuard],
              // children: [
                 // {   
                     // path: '', 
                     children:[
                           // { path: '',  redirectTo: 'user-crud', pathMatch: 'full' },
                           { path: 'user',  component: UserComponent, canActivate: [DashboardGuard] },
                           { path: 'user-crud',  component: UserCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'user-crud/:id',  component: UserCrudComponent, canActivate: [DashboardGuard] },
                      
                           { path: 'receipt',  component: ReceiptComponent, canActivate: [DashboardGuard] },  
                           { path: 'receipt-items',  component: ReceiptItemsComponent, canActivate: [DashboardGuard] },  
                           { path: 'receipt-items/:id',  component: ReceiptItemsComponent, canActivate: [DashboardGuard] },  
                           { path: 'receipt-update/:id',  component: ReceiptUpdateComponent, canActivate: [DashboardGuard] },                               
                           { path: 'receipt-list-items/:id',  component: ReceiptListItemsComponent, canActivate: [DashboardGuard] },

                           { path: 'sale',  component: SaleComponent, canActivate: [DashboardGuard] },    
                           { path: 'sale-items',  component: SaleItemsComponent, canActivate: [DashboardGuard] },                               
                           { path: 'sale-items/:id',  component: SaleItemsComponent, canActivate: [DashboardGuard] },                               
                          //  { path: 'sale-update/:sale_id/:contractor_id',  component: SaleUpdateComponent, canActivate: [DashboardGuard] },                               
                           { path: 'sale-update',  component: SaleUpdateComponent, canActivate: [DashboardGuard] },                               
                           { path: 'sale-list-items/:id',  component: SaleListItemsComponent, canActivate: [DashboardGuard] },


                           { path: 'currency',  component: CurrencyComponent, canActivate: [DashboardGuard] },
                           { path: 'currency-crud',  component: CurrencyCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'currency-crud/:id',  component: CurrencyCrudComponent, canActivate: [DashboardGuard] },

                           { path: 'currency-rate',  component: CurrencyRateComponent, canActivate: [DashboardGuard] },  
                           { path: 'currency-rate-crud',  component: CurrencyRateCrudComponent, canActivate: [DashboardGuard] },  
                           { path: 'currency-rate-crud/:id',  component: CurrencyRateCrudComponent, canActivate: [DashboardGuard] },  

                           { path: 'contact',  component: ContactComponent, canActivate: [DashboardGuard] },
                           { path: 'contact-crud',  component: ContactCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'contact-crud/:id',  component: ContactCrudComponent, canActivate: [DashboardGuard] },  

                           { path: 'account',  component: AccountComponent, canActivate: [DashboardGuard] },
                           { path: 'account/:id',  component: AccountComponent, canActivate: [DashboardGuard] },
                           { path: 'account-crud',  component: AccountCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'account-crud/:id',  component: AccountCrudComponent, canActivate: [DashboardGuard] },


                           { path: 'transaction-purpose-type',  component: TransactionPurposeTypeComponent, canActivate: [DashboardGuard] },
                           { path: 'transaction-purpose-type-crud',  component: TransactionPurposeTypeCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'transaction-purpose-type-crud/:id',  component: TransactionPurposeTypeCrudComponent, canActivate: [DashboardGuard] },  


                           { path: 'contractor',  component: ContractorComponent, canActivate: [DashboardGuard] },
                           { path: 'contractor-crud',  component: ContractorCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'contractor-crud/:id',  component: ContractorCrudComponent, canActivate: [DashboardGuard] },

                           { path: 'contractor-type',  component: ContractorTypeComponent, canActivate: [DashboardGuard] },
                           { path: 'contractor-type-crud',  component: ContractorTypeCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'contractor-type-crud/:id',  component: ContractorTypeCrudComponent, canActivate: [DashboardGuard] },  

                           { path: 'ownership-type',  component: OwnershipTypeComponent, canActivate: [DashboardGuard] },
                           { path: 'ownership-type-crud',  component: OwnershipTypeCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'ownership-type-crud/:id',  component: OwnershipTypeCrudComponent, canActivate: [DashboardGuard] },  

                           { path: 'country',  component: CountryComponent, canActivate: [DashboardGuard] },
                           { path: 'country-crud',  component: CountryCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'country-crud/:id',  component: CountryCrudComponent, canActivate: [DashboardGuard] },
                           
                           { path: 'region',  component: RegionComponent, canActivate: [DashboardGuard] },
                           { path: 'city',  component: CityComponent, canActivate: [DashboardGuard] },
                           
                           { path: 'unit',  component: UnitComponent, canActivate: [DashboardGuard]},
                           { path: 'unit-crud',  component: UnitCrudComponent, canActivate: [DashboardGuard], canDeactivate: [CanDeactivateGuard] },
                           { path: 'unit-crud/:id',  component: UnitCrudComponent, canActivate: [DashboardGuard], canDeactivate: [CanDeactivateGuard] },
                
                           { path: 'manufacture',  component: ManufactureComponent, canActivate: [DashboardGuard] },
                           { path: 'manufacture-crud',  component: ManufactureCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'manufacture-crud/:id',  component: ManufactureCrudComponent, canActivate: [DashboardGuard] },
                           
                           { path: 'cashbox',  component: CashboxComponent, canActivate: [DashboardGuard] },

                           { path: 'category',  component: CategoryComponent, canActivate: [DashboardGuard] },
                           { path: 'category-crud',  component: CategoryCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'category-crud/:id',  component: CategoryCrudComponent, canActivate: [DashboardGuard] },
                          
                           { path: 'store',  component: StoreComponent, canActivate: [DashboardGuard] },
                           { path: 'store-crud',  component: StoreCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'store-crud/:id',  component: StoreCrudComponent, canActivate: [DashboardGuard] },

                           { path: 'product',  component: ProductComponent , canActivate: [DashboardGuard]},
                           { path: 'product-crud',  component: ProductCrudComponent , canActivate: [DashboardGuard]},
                           { path: 'product-crud/:id',  component: ProductCrudComponent , canActivate: [DashboardGuard]},

                          
                           { path: 'product-tarif',  component: ProductTarifComponent , canActivate: [DashboardGuard]},
                           { path: 'product-tarif-crud',  component: ProductTarifCrudComponent , canActivate: [DashboardGuard]},
                           { path: 'product-tarif-crud/:id',  component: ProductTarifCrudComponent , canActivate: [DashboardGuard]},

                           { path: 'tarif-name',  component: TarifNameComponent , canActivate: [DashboardGuard]},
                           { path: 'tarif-name-crud',  component: TarifNameCrudComponent , canActivate: [DashboardGuard]},
                           { path: 'tarif-name-crud/:id',  component: TarifNameCrudComponent , canActivate: [DashboardGuard]},

                           { path: 'product_storage',  component: ProductStorageComponent, canActivate: [DashboardGuard] },
                       
                           { path: 'expense',  component: ExpenseComponent, canActivate: [DashboardGuard] },
                           { path: 'expense-crud',  component: ExpenseCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'expense-crud/:id',  component: ExpenseCrudComponent, canActivate: [DashboardGuard] },

                           { path: 'position',  component: PositionComponent, canActivate: [DashboardGuard] },
                           { path: 'position/:id',  component: PositionComponent, canActivate: [DashboardGuard] },
                           { path: 'position-crud',  component: PositionCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'position-crud/:id',  component: PositionCrudComponent, canActivate: [DashboardGuard] },   

                           { path: 'expense-type',  component: ExpenseTypeComponent, canActivate: [DashboardGuard] },
                           { path: 'expense-type-crud',  component: ExpenseTypeCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'expense-type-crud/:id',  component: ExpenseTypeCrudComponent, canActivate: [DashboardGuard] }, 

                           { path: 'operation-type',  component: OperationTypeComponent, canActivate: [DashboardGuard] }, 

                           { path: 'operation',  component: OperationComponent, canActivate: [DashboardGuard] },
                           { path: 'operation-items',  component: OperationItemsComponent, canActivate: [DashboardGuard] },
                           { path: 'operation-items/:id',  component: OperationItemsComponent, canActivate: [DashboardGuard] },
                           { path: 'operation-list-item/:id',  component: OperationListItemComponent, canActivate: [DashboardGuard] },

                           { path: 'cell',  component: CellComponent, canActivate: [DashboardGuard] },
                           { path: 'cell-crud',  component: CellCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'cell-crud/:id',  component: CellCrudComponent, canActivate: [DashboardGuard] },  
                           
                           { path: 'news',  component: NewsComponent, canActivate: [DashboardGuard] },
                           { path: 'news-crud',  component: NewsCrudComponent, canActivate: [DashboardGuard] },
                           { path: 'news-crud/:id',  component: NewsCrudComponent, canActivate: [DashboardGuard] },  

                           { path: 'report',  component: ReportComponent, canActivate: [DashboardGuard] },

                       ]
                  // }
              // ]  
           },
           // { path: 'user-crud',  component: UserCrudComponent, canActivate: [DashboardGuard] },
           // { path: 'user-crud/:id',  component: UserCrudComponent, canActivate: [DashboardGuard] },


           { path: 'role',  component: RoleComponent, canActivate: [DashboardGuard] },
           { path: 'role-crud',  component: RoleCrudComponent, canActivate: [DashboardGuard] },
           { path: 'role-crud/:id',  component: RoleCrudComponent, canActivate: [DashboardGuard] },
           

           { path: 'store-type',  component: StoreTypeComponent, canActivate: [DashboardGuard] },
           { path: 'store-type-crud',  component: StoreTypeCrudComponent, canActivate: [DashboardGuard] },
           { path: 'store-type-crud/:id',  component: StoreTypeCrudComponent, canActivate: [DashboardGuard] },
           
       
    ]     
  }
];

@NgModule({
  imports: [
  	 RouterModule.forChild(dashboardRoutes)
  ],
   exports: [
    RouterModule
  ]
})
export class DashboardRoutingModule { }
export const routingComponents = [
       SidebarComponent,
       ContentComponent,
       HeaderComponent,
       FooterComponent,
       UserComponent,
       UserCrudComponent,
       SettingComponent,
       StoreComponent,
       CurrencyComponent,
       CurrencyCrudComponent,
       StoreTypeComponent,
       StoreTypeCrudComponent,
       CategoryComponent,
       CategoryCrudComponent,
       CountryComponent,
       CountryCrudComponent,
       UnitComponent,
       UnitCrudComponent,
       ManufactureComponent,
       ManufactureCrudComponent,
       ProductComponent,
       ProductCrudComponent,
       StoreCrudComponent,
       RoleComponent,
       RoleCrudComponent,
       ExpenseComponent,
       ExpenseCrudComponent,
       ExpenseTypeComponent,
       ExpenseTypeCrudComponent,
       PermissionComponent,
       PermissionCrudComponent,
       ContractorComponent,
       ContractorCrudComponent,
       ContractorTypeComponent,
       ContractorTypeCrudComponent,
       ReceiptComponent,
       ReceiptItemsComponent,
       CurrencyRateComponent,
       CurrencyRateCrudComponent,
       SaleComponent,
       SaleItemsComponent,
       SaleUpdateComponent,
       SaleListItemsComponent,
       CashboxComponent,
       ProductStorageComponent,
       OperationTypeComponent,
       OperationComponent,
       OperationItemsComponent,
       OperationListItemComponent,
       CellComponent,
       CellCrudComponent,
       ContactComponent,
       ContactCrudComponent,
       AccountComponent,
       AccountCrudComponent,
       PositionComponent,
       PositionCrudComponent,
       ProductTarifComponent,
       ProductTarifCrudComponent,
       OwnershipTypeComponent,
       OwnershipTypeCrudComponent,
       TarifNameComponent,
       TarifNameCrudComponent,
       RegionComponent,
       CityComponent,
       NewsComponent,
       NewsCrudComponent,
       ReportComponent,
       FilterComponent,
       NotificationComponent
]



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/dashboard-routing.module.ts